import {
  SET_UI_FLAG,
} from 'config/types';

export default function uiFlagReducer(state = {}, { type = '' }) {
  if (SET_UI_FLAG === type) {
    return {
      ...state,
      uiFlag: true,
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/uiFlag.js